import { AlertTriangle, Clock3, Wrench } from 'lucide-react';

const MaintenancePage = () => {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-white px-6">
      {/* Background */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(circle at 80% 10%, rgba(246,150,255,.18), transparent 55%), radial-gradient(circle at 10% 90%, rgba(68,206,237,.15), transparent 50%)',
        }}
      />

      {/* Grid */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage:
            'repeating-linear-gradient(45deg,#302764 0px,#302764 1px,transparent 1px,transparent 24px)',
        }}
      />

      {/* Floating Shapes */}
      <div className="absolute left-10 top-16 text-7xl text-[#702B73] animate-float">⚙</div>

      <div className="absolute right-16 top-24 text-6xl animate-float-delay">🔧</div>

      <div className="absolute bottom-16 left-12 text-6xl text-[#44CEED] animate-float">⚙</div>

      <div className="absolute bottom-20 right-10 text-6xl animate-float-delay">🛠</div>

      {/* Bottom Gradient */}
      <div
        className="absolute bottom-0 left-0 h-1.5 w-full"
        style={{
          background: 'linear-gradient(270deg,#44CEED 0%,#F696FF 50%,#DD2345 100%)',
        }}
      />

      <div className="relative z-10 w-full max-w-2xl text-center">
        {/* Icon */}
        <div className="mx-auto mb-8 flex h-24 w-24 items-center justify-center rounded-3xl bg-gradient-to-r from-[#702B73] to-[#DD2345] shadow-2xl animate-pulse">
          <Wrench className="h-11 w-11 text-white" />
        </div>

        {/* Badge */}
        <span className="rounded-full border border-[#702B7330] bg-[#F696FF20] px-5 py-2 text-xs font-bold uppercase tracking-[0.3em] text-[#702B73]">
          Scheduled Maintenance
        </span>

        {/* Title */}
        <h1
          className="mt-8 text-5xl font-black md:text-7xl"
          style={{
            background: 'linear-gradient(270deg,#702B73,#DD2345)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontFamily: 'Georgia, serif',
          }}
        >
          Well Be Back Soon
        </h1>

        {/* Description */}
        <p
          className="mx-auto mt-6 max-w-xl text-lg leading-8"
          style={{
            color: 'rgba(48,39,100,.72)',
            fontFamily: 'Georgia, serif',
          }}
        >
          Our platform is currently undergoing scheduled maintenance to improve performance,
          stability, and your overall experience.
          <br />
          Thank you for your patience.
        </p>

        {/* Divider */}
        <div className="my-10 flex items-center gap-4">
          <div className="h-px flex-1 bg-gradient-to-r from-transparent to-[#702B7330]" />

          <AlertTriangle className="text-[#DD2345]" size={20} />

          <div className="h-px flex-1 bg-gradient-to-r from-[#702B7330] to-transparent" />
        </div>

        {/* Status Card */}
        <div
          className="mx-auto flex max-w-lg items-center gap-5 rounded-3xl border p-6 shadow-lg"
          style={{
            borderColor: 'rgba(112,43,115,.15)',
            background: 'linear-gradient(135deg,rgba(68,206,237,.08),rgba(246,150,255,.12))',
          }}
        >
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-r from-[#44CEED] to-[#F696FF]">
            <Clock3 className="text-white" />
          </div>

          <div className="text-left">
            <h3 className="text-sm font-bold uppercase tracking-wider text-[#702B73]">
              Maintenance in Progress
            </h3>

            <p className="mt-1 text-sm text-[#302764aa]">
              Our engineers are working to restore the service as quickly as possible.
            </p>
          </div>
        </div>

        {/* Loading Dots */}
        <div className="mt-10 flex justify-center gap-3">
          <span className="h-3 w-3 animate-bounce rounded-full bg-[#44CEED]" />
          <span
            className="h-3 w-3 animate-bounce rounded-full bg-[#DD2345]"
            style={{ animationDelay: '.15s' }}
          />
          <span
            className="h-3 w-3 animate-bounce rounded-full bg-[#44CEED]"
            style={{ animationDelay: '.3s' }}
          />
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
